import { StyledMe2onBundle } from './style';
import { Box } from '@mui/system';
import { EBadgeType, EBundlesInternalViewModel } from 'utils/enums';
import BundlePrice from '../BundlePrice';
import { BundleProps } from 'utils/types';
import { checkIfOlderOsVersions } from 'utils';
import { useEffect, useState } from 'react';
import { BadgeData } from 'components/Badge/types';
import { Me2onSaleBadge } from 'components/Badge/Sale/Me2onSaleBadge';

export const Me2onBundle: React.FC<BundleProps> = ({
  price,
  productList,
  badges = [],
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  salePercentage = 0,
  salePercentageDisplayType,
  bundleButtonColor,
}) => {
  const [emblemBadge, setEmblemBadge] = useState<any>(null);
  const [isOldVersion, setIsOldVersion] = useState<string>('');

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadge(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadge(null);
    }
  }, [badges]);

  useEffect(() => {
    if (checkIfOlderOsVersions()) {
      setIsOldVersion('products-sub--ios13');
    }
  }, []);

  return (
    <StyledMe2onBundle
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      quantityDisplay={
        productList.length > 0 ? productList[0].quantityDisplay : '100'
      }
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      bundleButtonColor={bundleButtonColor}
      isThreeProducts={productList.length > 3}
    >
      <Box className="container">
        {emblemBadge && (
          <div className="badge-emblem">
            <img
              className="badge-emblem--image"
              alt="badge-emblem"
              src={emblemBadge.imageUrl}
            />
          </div>
        )}
        {salePercentage > 0 && (
          <Me2onSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        {productList.length > 0 && (
          <Box className="amount">
            <Box className="amount-main">
              <span className="price">
                {productList[0].quantityDisplay || '100'}
              </span>
            </Box>
            {salePercentage > 0 && (
              <p className="amount-stroked">
                {productList[0].strokedSaleQuantity}
              </p>
            )}
          </Box>
        )}
        <Box className="products">
          {productList.length > 1 && (
            <Box className={`products-sub ${isOldVersion}`}>
              {productList?.slice(1).map((product, i) => {
                return (
                  <Box className="product" key={i}>
                    <Box className="product-image">
                      <img
                        alt="coin"
                        className="image"
                        src={product.images.product}
                      />
                    </Box>
                    <Box className="product-amount">
                      {product.quantityDisplay || 100}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          )}
          {productList.length > 0 && (
            <Box className="products-main">
              <img
                src={productList[0].images.product}
                alt="product"
                className="products-main-image"
              />
              <BundlePrice
                price={price}
                type={EBundlesInternalViewModel.ME2ON}
                whiteStripe={true}
              />
            </Box>
          )}
        </Box>
      </Box>
    </StyledMe2onBundle>
  );
};
